import { ViewEditMode } from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import { orderCartlUrl } from "@saleor/createOrder/urls";
import { Pagination, Sort } from "@saleor/types";

export enum DomesticOrderSortField {
  item_no = "item_no",
  PRICE_PER_UNIT = "PRICE_PER_UNIT",
  REMAINING_QUANTITY = "REMAINING_QUANTITY",
  TOTAL_QUANTITY = "TOTAL_QUANTITY"
}
export type DomesticOrderUrlSort = Sort<DomesticOrderSortField>;
export type DomesticOrderQueryParams = Pagination &
  DomesticOrderUrlSort & { editMode: ViewEditMode; enabledCreate?: string };

export const contractDetaiUrlParamTab = (id: string) => (
  params?: DomesticOrderQueryParams
): string => {
  if (params === undefined) {
    return orderCartlUrl(id);
  } else {
    return orderCartlUrl(id, params);
  }
};
